import React, { useContext } from 'react';
import { BALANCE_UP_STEPS_MAP, ENROLLMENT_TYPES } from '../constants';
import { BalanceUpContext } from '../pages';
import BalanceUpAchTransfer from './BalanceUpEligibilityNotice';
import BalanceUpHappyEnroll from './BalanceUpHappyEnroll';

interface IProps {
  handleEnroll: (type: number) => void;
  isEligible: boolean;
  enrollmentType: string;
  overDraftLimit: string | number;
}

const BalanceUpEnroll = ({ handleEnroll, enrollmentType, overDraftLimit }: IProps) => {
  const contextData = useContext(BalanceUpContext);

  const handleClick = () => {
    handleEnroll(BALANCE_UP_STEPS_MAP.ENROLLMENT);
  };

  const getActiveComponent = () => {
    switch (enrollmentType) {
      case ENROLLMENT_TYPES.ACC_UPGRADE_REQ:
        return <BalanceUpAchTransfer onSubmit={handleClick} upgrade />;
      case ENROLLMENT_TYPES.ACH_TRANSFER_REQ:
        return <BalanceUpAchTransfer onSubmit={handleClick} />;
      case ENROLLMENT_TYPES.HAPPY_FLOW_ENROLL:
        return (
          <BalanceUpHappyEnroll
            onSubmit={handleClick}
            overDraftLimit={overDraftLimit}
            isLoading={contextData.isLoadingState}
          />
        );

      default:
        return <div hidden className='hidden' />;
    }
  };

  return getActiveComponent();
};

export default BalanceUpEnroll;
